export default defineNuxtPlugin(() => {
  window.VERSION = "v1.0.0-104-gf62be37af";
});
